import type { Language } from '../contexts/TranslationContext';

const AGENT_ARTWORK_WIDTHS = [320, 640, 960, 1200] as const;

export interface AgentArtworkImageAsset {
  avifSrcSet: string;
  fallbackSrc: string;
  webpSrcSet: string;
  width: number;
  height: number;
  preloadHref: string;
  sizes: string;
}

function agentArtwork(agent: 'consultant' | 'auditor', language: Language): AgentArtworkImageAsset {
  const basePath = `/assets/agents/artwork/${language}/${agent}`;
  const srcSet = (format: 'avif' | 'webp') => AGENT_ARTWORK_WIDTHS
    .map((width) => `${basePath}-${width}.${format} ${width}w`)
    .join(', ');

  return {
    avifSrcSet: srcSet('avif'),
    fallbackSrc: `${basePath}-1200.webp`,
    webpSrcSet: srcSet('webp'),
    width: 1200,
    height: 900,
    preloadHref: `${basePath}-640.avif`,
    sizes: '(min-width: 1024px) 576px, (min-width: 416px) 384px, calc(100vw - 2rem)',
  };
}

export const CONSULTANT_AGENT_ARTWORK: Record<Language, AgentArtworkImageAsset> = {
  fr: agentArtwork('consultant', 'fr'),
  en: agentArtwork('consultant', 'en'),
};

export const TRANSPORT_AGENT_ARTWORK: Record<Language, AgentArtworkImageAsset> = {
  fr: agentArtwork('auditor', 'fr'),
  en: agentArtwork('auditor', 'en'),
};
